import { useFlags } from "launchdarkly-react-client-sdk";
import { type FeatureFlags } from "../featureFlags";

export const useFeatureFlag = (flag: FeatureFlags) => {
  const flags = useFlags();

  return flags[flag];
};
